import type { HTMLAttributes, ReactElement } from 'react';

import FallbackSpinner from '@/ErrorBoundaries/FallbackSpinner/FallbackSpinner';
import { NAVIGATION_HEIGHT } from '@/modules/constants/navigation';
import type { BreakpointsProps } from '@/types';
import {
  StyledGalleryViewer,
  StyledGalleryViewerCTAs,
  StyledGalleryViewerCTAsWrapper,
  StyledGalleryViewerTabs,
} from './GalleryViewer.styles';

export interface GalleryViewerProps
  extends HTMLAttributes<HTMLDivElement>,
    BreakpointsProps<Pick<GalleryViewerProps, 'width' | 'height'>> {
  width?: string;
  height?: string;
  tabs?: ReactElement;
  actions?: ReactElement;
  isLoading?: boolean;
  offsetTop?: number;
}

const GalleryViewer = ({
  tabs,
  actions,
  children,
  isLoading,
  offsetTop = NAVIGATION_HEIGHT,
  ...restProps
}: GalleryViewerProps) => {
  return isLoading ? (
    <FallbackSpinner />
  ) : (
    <StyledGalleryViewer {...restProps}>
      <StyledGalleryViewerCTAsWrapper>
        <StyledGalleryViewerCTAs>
          <div>{actions}</div>
          <StyledGalleryViewerTabs>{tabs}</StyledGalleryViewerTabs>
        </StyledGalleryViewerCTAs>
      </StyledGalleryViewerCTAsWrapper>
      {children}
    </StyledGalleryViewer>
  );
};

export default GalleryViewer;
